module.exports = __webpack_public_path__ + "static/img/cooperate.5b702fb3.png";